import React from "react";
import { Link } from "react-router-dom";

const ICON = "/icon-totalpl.png";
const LOGO_LONG = "/brand/logo-totalpl.png";

/**
 * BrandMark — TotalPL identity, ALWAYS clickable (links to "/").
 * variant="long"  -> logo orizzontale completo (PNG con testo, niente testo extra).
 * variant="icon"  -> solo icona quadrata + testo Total/PL rendered (per dark sidebar).
 */
export function BrandMark({ variant = "icon", height = 48, showText = true, theme = "dark", className = "", to = "/totalpl" }) {
    const inner = variant === "long" ? (
        <img
            src={LOGO_LONG}
            alt="TotalPL · PrintLab"
            style={{ height, width: "auto", display: "block" }}
        />
    ) : (
        <>
            <img
                src={ICON}
                alt="TotalPL"
                style={{ width: height, height: height }}
                className="rounded-lg bg-white p-1 shadow-sm"
            />
            {showText && (
                <div className="flex flex-col leading-none">
                    <div
                        className="font-extrabold tracking-tight"
                        style={{ fontSize: height * 0.45, color: theme === "dark" ? "#fff" : "var(--navy)" }}
                    >
                        Total<span className="grad-text">PL</span>
                    </div>
                    <div
                        className="mono uppercase mt-1 font-semibold"
                        style={{
                            fontSize: Math.max(9, height * 0.18),
                            color: theme === "dark" ? "#8B95B0" : "var(--muted)",
                            letterSpacing: "0.16em",
                        }}
                    >
                        PrintLab
                    </div>
                </div>
            )}
        </>
    );

    return (
        <Link
            to={to}
            data-testid="brand-mark"
            className={`inline-flex items-center ${variant === "long" ? "" : "gap-3"} transition hover:opacity-80 ${className}`}
            aria-label="TotalPL · home"
        >
            {inner}
        </Link>
    );
}

export default BrandMark;
